/* GodsOwnCase theme JS — cart drawer, carousels, countdown, mobile menu, qty, image swap */
(function () {
  "use strict";

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var toggle = $("[data-menu-toggle]");
    var drawer = $("[data-mobile-menu]");
    if (!toggle || !drawer) return;
    var close = $("[data-menu-close]", drawer);
    function open() { drawer.classList.add("is-open"); document.body.classList.add("no-scroll"); }
    function shut() { drawer.classList.remove("is-open"); document.body.classList.remove("no-scroll"); }
    toggle.addEventListener("click", open);
    if (close) close.addEventListener("click", shut);
    drawer.addEventListener("click", function (e) { if (e.target === drawer) shut(); });
  }

  /* Remember collection browsing within this tab; never use an external URL. */
  function collectionPath(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && /\/collections\/(all|pastel-glass-cases|anime-cases|car-culture)\/?$/.test(url.pathname) ? url.pathname : '';
    } catch (e) { return ''; }
  }
  function updateContinueLinks() {
    var path = '';
    try {
      var current = collectionPath(window.location.href);
      if (current) sessionStorage.setItem('goc:last-collection', current);
      path = collectionPath(sessionStorage.getItem('goc:last-collection') || '');
    } catch (e) {}
    if (path) $$('[data-choose-another]').forEach(function (link) { link.href = path; });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = {
    el: null,
    open: function () {
      this.el = this.el || $("[data-cart-drawer]");
      if (!this.el) return;
      this.el.classList.add("is-open");
      document.body.classList.add("no-scroll");
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove("is-open");
      document.body.classList.remove("no-scroll");
    },
    refresh: function () {
      var self = this;
      fetch(window.routes.cart_url + "?section_id=cart-drawer")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.querySelector("[data-cart-drawer-inner]");
          var current = $("[data-cart-drawer-inner]");
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          self.updateCount(doc);
          self.bindQty();
          updateContinueLinks();
        });
    },
    updateCount: function (doc) {
      var src = (doc || document).querySelector("[data-cart-count-src]") || (doc || document).querySelector("[data-cart-count]");
      var count = src ? src.textContent : null;
      if (count !== null) $$("[data-cart-count]").forEach(function (n) { n.textContent = count; n.classList.toggle("is-empty", String(count).trim() === "0"); });
    },
    bindQty: function () {
      $$("[data-line-change]").forEach(function (input) {
        if (input.dataset.cartBound) return;
        input.dataset.cartBound = "true";
        input.addEventListener("change", function () {
          var form = input.closest("form.cart-page");
          if (form) {
            var update = form.querySelector("button[name=update]");
            if (form.requestSubmit) form.requestSubmit(update); else update.click();
            return;
          }
          var line = input.getAttribute("data-line");
          cartDrawer.changeLine(line, input.value);
        });
      });
      $$("[data-line-remove]").forEach(function (btn) {
        if (btn.dataset.cartBound) return;
        btn.dataset.cartBound = "true";
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          cartDrawer.changeLine(btn.getAttribute("data-line"), 0);
        });
      });
    },
    changeLine: function (line, qty) {
      fetch(window.routes.cart_change_url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
      }).then(function () { cartDrawer.refresh(); });
    }
  };

  /* expose a global hook so other scripts (Custom Lab) can open/refresh the drawer */
  window.cartDrawerOpen = function () { cartDrawer.refresh(); cartDrawer.open(); };

  function initCart() {
    updateContinueLinks();
    document.addEventListener("click", function (e) {
      var openBtn = e.target.closest("[data-cart-open]");
      if (openBtn) { e.preventDefault(); cartDrawer.open(); }
      var closeBtn = e.target.closest("[data-cart-close]");
      if (closeBtn) { e.preventDefault(); cartDrawer.close(); }
      var overlay = e.target.closest("[data-cart-overlay]");
      if (overlay) cartDrawer.close();
      /* "keep shopping" closes the drawer and lets the link go to the designs */
      if (e.target.closest("[data-cart-keep-shopping]")) cartDrawer.close();
    });
    cartDrawer.bindQty();

    /* Show progress for the native cart update/checkout submission. */
    $$('form.cart-page').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (form.dataset.cartBusy === 'true') { event.preventDefault(); return; }
        form.dataset.cartBusy = 'true';
        $$('[data-line-change]', form).forEach(function (input) { input.readOnly = true; });
        var submitter = event.submitter || (document.activeElement && document.activeElement.form === form ? document.activeElement : null);
        if (submitter && submitter.name && !form.querySelector('[data-cart-submit-proxy]')) {
          var proxy = document.createElement('input');
          proxy.type = 'hidden';
          proxy.name = submitter.name;
          proxy.value = submitter.value;
          proxy.setAttribute('data-cart-submit-proxy', '');
          form.appendChild(proxy);
        }
        var status = $('[data-cart-page-status]', form);
        if (status) {
          status.textContent = submitter && submitter.name === 'checkout' ? 'Opening secure checkout…' : 'Updating your bag…';
          status.hidden = false;
        }
        $$('[data-qty-btn], button[name="update"], button[name="checkout"]', form).forEach(function (button) {
          button.disabled = true;
        });
      });
    });

    /* Browsers may restore the submitted page from their back/forward cache. */
    window.addEventListener('pageshow', function () {
      $$('form.cart-page').forEach(function (form) {
        delete form.dataset.cartBusy;
        $$('[data-line-change]', form).forEach(function (input) { input.readOnly = false; });
        $$('[data-cart-submit-proxy]', form).forEach(function (proxy) { proxy.remove(); });
        $$('[data-qty-btn], button[name="update"], button[name="checkout"]', form).forEach(function (button) { button.disabled = false; });
        var status = $('[data-cart-page-status]', form);
        if (status) { status.textContent = ''; status.hidden = true; }
      });
    });

    /* AJAX add-to-cart from product forms with data-ajax */
    $$("form[data-ajax-cart]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector("[type=submit]");
        if (btn) btn.classList.add("is-loading");
        fetch(window.routes.cart_add_url, {
          method: "POST",
          headers: { Accept: "application/javascript" },
          body: new FormData(form)
        }).then(function (r) { return r.json(); })
          .then(function () { cartDrawer.refresh(); cartDrawer.open(); })
          .finally(function () { if (btn) btn.classList.remove("is-loading"); });
      });
    });
  }

  /* ---------- Quantity steppers (product + cart pages) ---------- */
  function initQtySteppers() {
    $$("[data-qty]").forEach(function (wrap) {
      var input = $("input", wrap);
      $$("[data-qty-btn]", wrap).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var step = btn.getAttribute("data-qty-btn") === "up" ? 1 : -1;
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  function initProductGallery() {
    var gallery = $("[data-product-gallery]");
    if (!gallery) return;
    var main = $("[data-gallery-main]", gallery);
    $$("[data-gallery-thumb]", gallery).forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-src");
        if (main && src) main.src = src;
        $$("[data-gallery-thumb]", gallery).forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    $$("[data-variant-selects]").forEach(function (form) {
      var selects = $$("select, input[type=radio]:checked", form);
      form.addEventListener("change", function () {
        var chosen = $$("[data-option]", form).map(function (g) {
          var sel = g.querySelector("select");
          if (sel) return sel.value;
          var radio = g.querySelector("input:checked");
          return radio ? radio.value : null;
        });
        var data = JSON.parse(form.getAttribute("data-variants") || "[]");
        var match = data.find(function (v) { return JSON.stringify(v.options) === JSON.stringify(chosen); });
        var idInput = form.querySelector("[data-variant-id]");
        var priceEl = $("[data-variant-price]");
        var btn = form.querySelector("[data-add-btn]");
        if (match) {
          if (idInput) idInput.value = match.id;
          if (priceEl) priceEl.textContent = match.price;
          if (btn) { btn.disabled = !match.available; btn.textContent = match.available ? btn.getAttribute("data-label") : "Sold out"; }
        }
      });
    });
  }

  /* ---------- Marquee (duplicate content for seamless scroll) ---------- */
  function initMarquee() {
    $$("[data-marquee]").forEach(function (m) {
      var track = $("[data-marquee-track]", m);
      if (!track) return;
      track.innerHTML += track.innerHTML;
    });
  }

  /* ---------- Countdown timer ---------- */
  function initCountdown() {
    $$("[data-countdown]").forEach(function (el) {
      var target = new Date(el.getAttribute("data-countdown")).getTime();
      if (isNaN(target)) {
        // fallback: N days from now
        var days = parseInt(el.getAttribute("data-days") || "9", 10);
        target = Date.now() + days * 864e5;
      }
      function tick() {
        var diff = Math.max(0, target - Date.now());
        var d = Math.floor(diff / 864e5);
        var h = Math.floor((diff % 864e5) / 36e5);
        var m = Math.floor((diff % 36e5) / 6e4);
        var s = Math.floor((diff % 6e4) / 1e3);
        set("d", d); set("h", h); set("m", m); set("s", s);
      }
      function set(k, v) { var n = el.querySelector("[data-cd='" + k + "']"); if (n) n.textContent = String(v).padStart(2, "0"); }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Simple drag/scroll carousels ---------- */
  function initCarousels() {
    $$("[data-carousel]").forEach(function (track) {
      var prev = track.parentElement.querySelector("[data-carousel-prev]");
      var next = track.parentElement.querySelector("[data-carousel-next]");
      var amt = function () { return track.clientWidth * 0.8; };
      if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -amt(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { track.scrollBy({ left: amt(), behavior: "smooth" }); });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $$("[data-reveal]").forEach(function (n) { io.observe(n); });
  }

  /* ---------------------------------------------------------------
     Shop by model. Remembers the visitor's iPhone and preselects it
     on every product page, so choosing happens once, not every time.
     --------------------------------------------------------------- */
  var MODEL_KEY = "goc:model";

  function getModel() {
    try { return localStorage.getItem(MODEL_KEY) || ""; } catch (e) { return ""; }
  }
  function setModel(v) {
    try { localStorage.setItem(MODEL_KEY, v); } catch (e) {}
  }

  function initModelRow() {
    var row = $("[data-model-row]");
    var saved = getModel();

    if (row) {
      var current = $("[data-model-current]", row);
      var paint = function () {
        var m = getModel();
        $$("[data-model-chip]", row).forEach(function (c) {
          c.classList.toggle("is-active", c.getAttribute("data-model-chip") === m);
        });
        if (current) {
          current.hidden = !m;
          current.textContent = m ? "Saved: " + m : "";
        }
      };
      row.addEventListener("click", function (e) {
        var chip = e.target.closest("[data-model-chip]");
        if (!chip) return;
        var name = chip.getAttribute("data-model-chip");
        setModel(getModel() === name ? "" : name);
        paint();
        var go = row.getAttribute("data-shop-url");
        if (go && getModel()) window.location.href = go;
      });
      paint();
    }

    /* product page: select the saved model if this product offers it */
    if (!saved) return;
    $$("[data-variant-selects]").forEach(function (form) {
      var hit = $$("input[type=radio]", form).find(function (i) { return i.value === saved; });
      if (!hit || hit.checked) return;
      hit.checked = true;
      form.dispatchEvent(new Event("change", { bubbles: true }));
      var note = $("[data-model-note]");
      if (note) { note.hidden = false; note.textContent = "Showing " + saved; }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMobileMenu();
    initCart();
    initQtySteppers();
    initProductGallery();
    initVariants();
    initMarquee();
    initCountdown();
    initCarousels();
    initReveal();
    initModelRow();
  });
})();
